const ProgressBar = ({ progress }) => {
    return (
        <div style={{
            width: '100%',
            height: '5px',
            backgroundColor: '#e0e0e0', // Light grey background
            borderRadius: '5px',
            marginBottom: '10px',
        }}>
            <div style={{
                height: '100%',
                width: `${progress}%`,
                backgroundColor: 'var(--Primary-Color)', // Adjust color as needed
                borderRadius: '5px',
                transition: 'width 0.3s ease-in-out', // Smooth transition
            }} />
        </div>
    );
};

export default ProgressBar;